import { BaseModel } from "../_base.model";

export class WarehouseBinItemModel extends BaseModel {
    binId: number;
    productId: number;
    priority?: number;
    quantity: number;
}